import {ActionTypes} from '../actions';
import {Picking} from '../../common/actionTypes';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingAgenciesList': false,
  'agenciesList': [],
  'loadingPendingItemsList': false,
  'pendingItemsList': [],
  'creatingInvoice': false,
  'markAllItems': false,
  'sequencesMarked': [],
};

export const lubricantsInvoicing = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_LUBRICANTS_INFO]: (state, action) => ({
      ...state,
      'loadingPendingItemsList': false,
      'pendingItemsList': [],
      'creatingInvoice': false,
      'markAllItems': false,
      'sequencesMarked': [],
    }),
    [Picking.FETCHING_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loadingAgenciesList': true,
    }),
    [Picking.FETCHED_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loadingAgenciesList': false,
      'agenciesList': action.response.data,
    }),
    [Picking.FETCHED_AGENCIES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingAgenciesList': false,
      'agenciesList': [],
    }),
    [Picking.FETCHING_PENDING_ITEMS_LIST]: (state, action) => ({
      ...state,
      'loadingPendingItemsList': true,
    }),
    [Picking.FETCHED_PENDING_ITEMS_LIST]: (state, action) => ({
      ...state,
      'loadingPendingItemsList': false,
      'pendingItemsList': action.response.data,
      'markAllItems': false,
      'sequencesMarked': [],
    }),
    [Picking.FETCHED_PENDING_ITEMS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingPendingItemsList': false,
      'pendingItemsList': [],
      'markAllItems': false,
      'sequencesMarked': [],
    }),
    [ActionTypes.SELECT_ALL_ITEMS]: (state, action) => ({
      ...state,
      'markAllItems': action.payload,
    }),
    [ActionTypes.CHANGE_SEQUENCES_MARKED]: (state, action) => ({
      ...state,
      'sequencesMarked': action.payload,
    }),
    [ActionTypes.CREATING_LUBRICANTS_INVOICE]: (state, action) => ({
      ...state,
      'creatingInvoice': true,
    }),
    [ActionTypes.CREATED_LUBRICANTS_INVOICE]: (state, action) => ({
      ...state,
      'creatingInvoice': false,
    }),
    [ActionTypes.CREATED_LUBRICANTS_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'creatingInvoice': false,
    }),
  })(state, action);
};
